import CentreAlign from "../../../../src/components/CentreAlign";
import Container from '@material-ui/core/Container';
import * as React from 'react';
export default {
  CentreAlign,
  Container,
  React
};